import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23ff21cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nav text-center"
}
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "_pointer-on-hover _prevent-text-select mr-3" }

import { onMounted, ref } from 'vue'

import { logoPathLight } from '@/data/room'
import { PropType } from 'vue'
import useTheme from '@/composables/useTheme'

export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultLayout',
  props: {
  haveNavbar: {
    type: Boolean,
    default: false,
  },
  canChangeLanguage: {
    type: Boolean,
    default: false,
  },
  theme: {
    type: String as PropType<'dark' | 'light'>,
    default: 'light',
  },
  haveEngine: {
    type: Boolean,
    default: false,
  },
  isMainEngine: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props
const currentRoomTooltip = ref(false)
const { changeTheme } = useTheme()
onMounted(() => {
  changeTheme(props.theme)
})

return (_ctx: any,_cache: any) => {
  const _component_LanguageDropdown = _resolveComponent("LanguageDropdown")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["public-layout", [__props.haveNavbar && '--with-navbar']])
  }, [
    (__props.haveNavbar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                class: "_prevent-text-select",
                src: _unref(logoPathLight),
                height: "54"
              }, null, 8, _hoisted_4)
            ]),
            (__props.canChangeLanguage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_LanguageDropdown)
                ]))
              : _createCommentVNode("", true),
            (__props.haveEngine)
              ? (_openBlock(), _createBlock(_component_Popper, {
                  key: 1,
                  class: "tooltip",
                  placement: "right",
                  show: currentRoomTooltip.value,
                  hover: true,
                  arrow: true,
                  content: 
            __props.isMainEngine
              ? _ctx.$t('current-room-tooltip.main-room')
              : _ctx.$t('current-room-tooltip.secondary-room')
          ,
                  onMouseover: _cache[0] || (_cache[0] = ($event: any) => (currentRoomTooltip.value = true)),
                  onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (currentRoomTooltip.value = false))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _withDirectives(_createVNode(_component_SvgIcon, {
                        class: "_pointer-on-hover",
                        icon: "siren",
                        "inherit-fill": true,
                        height: "21"
                      }, null, 512), [
                        [_vShow, !__props.isMainEngine]
                      ]),
                      _withDirectives(_createVNode(_component_SvgIcon, {
                        class: "_pointer-on-hover",
                        icon: "home",
                        "inherit-fill": true,
                        height: "21"
                      }, null, 512), [
                        [_vShow, __props.isMainEngine]
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["show", "content"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})